import React, {Component} from 'react'
import PropTypes from 'prop-types'

import ClientCommunicationMethodItem from "./ClientCommunicationMethodItem";

import {getContactMediumIconColour} from '../../../lib/communicationMethods'

class ClientCommunicationMethodsList extends Component {

    render(){
        const {communicationMethods, client_id} = this.props

        return (
            <div className="d-flex flex-column">
                {communicationMethods && communicationMethods.map(({contact_medium_id, contact_info, communication_method_id}) => {
                    const {icon, colour} = getContactMediumIconColour(contact_medium_id)
                    return <ClientCommunicationMethodItem
                        key={communication_method_id}
                        type={icon}
                        colour={colour}
                        value={contact_info}
                        contact_medium_id={contact_medium_id}
                        communication_method_id={communication_method_id}
                        client_id={client_id}
                        onEdit={() => this.setState({editing: true})}
                    />
                })}
            </div>
        )
    }


}

ClientCommunicationMethodsList.propTypes = {
    client_id: PropTypes.number.isRequired,
    communicationMethods: PropTypes.array.isRequired
}

export default ClientCommunicationMethodsList